<template>
  <div class="modal fade" id="upgrade-plan-modal" role="dialog" @click="$emit('close')">
    <div class="modal-dialog modal-lg" @click.stop>
      <div class="modal-dialog modal-lg">
        <div class="modal-content additonal-modal-content bd-rds-16">
          <div class="pd-t-20 pd-b-20 pd-l-5 pd-r-5">
            <div class="flex flex-flow-column flex-content-center font-bold text-size-20 pd-l-100 pd-r-100 text-plan-normal gap-10 text-center">
              <div class="text-center">
                <p>この機能を今すぐ利用できる</p>
                <div class="flex flex-content-baseline gap-5" style="line-height: 100%;">
                  <span class="text-size-40 plan-premium-text">プレミアム</span>
                  月額 <span class="text-size-40">{{ formattedPriceExTax }}</span> 円
                  <span class="label-normal">(税込 {{ formattedPriceInTax }} 円)</span>
                </div>
              </div>
              <p class="text-size-45 mr-t-20">
                初回登録なら<span class="text-dark-red">30日間無料</span>
              </p>
              <div class="text-size-24">
                登録から29日後の解約期限までに解約した場合、<br>
                料金は一切かかりません。
              </div>
              <button class="btn btn-warning btn-shadow btn-upgrade-plan bd-rds-8 text-size-22 pd-t-20 pd-b-15 pd-r-100 pd-l-100 mr-t-10" @click="handleUpgradePlan()">
                詳しくはこちら
                <i class="fa fa-arrow-circle-right fa-lg" aria-hidden="true"></i>
              </button>
              <a @click="$emit('close')" class="text-size-14 mr-t-20">閉じる</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MemberPlanService from '@/services/memberplanservice'
import Util from '@/common/utility'

export default {
  data () {
    return {
      loader: null,
      priceExTaxMonth: null,
      taxRate: null
    }
  },
  computed: {
    formattedPriceExTax () {
      return this.priceExTaxMonth != null ? Util.formatMoney(this.priceExTaxMonth) : '-'
    },
    formattedPriceInTax () {
      if (this.priceExTaxMonth == null || this.taxRate == null) return '-'
      return Util.formatMoney(Math.round(parseFloat(this.priceExTaxMonth) * (1 + parseFloat(this.taxRate))))
    }
  },
  methods: {
    handleUpgradePlan () {
      this.$emit('close')
      this.$router.push({name: 'Setting', params: {tab: 'plan-info'}})
    }
  },
  async mounted () {
    $('#upgrade-plan-modal').modal('show')
    try {
      const records = await MemberPlanService.getMemberPlanInfo()
      this.priceExTaxMonth = records.price_ex_tax_month
      this.taxRate = records.tax_rate
    } catch (e) {
      // giữ giá trị null, hiện '-'
    }
  },
  beforeDestroy () {
    this.$emit('close')
    $('.modal-backdrop').remove()
  }
}
</script>
<style scoped>
  .modal-dialog {
    margin-top: 200px;
  }
  @media (max-width: 425px) {
    .text-size-45 {
      font-size: 20px;
    }
    .text-size-40 {
      font-size: 18px;
    }
    .text-size-20 {
      font-size: 14px;
    }
    .text-size-22 {
      font-size: 16px;
    }
    .text-size-24 {
      font-size: 14px;
    }
    .pd-r-100 {
      padding-right: 10px;
    }
    .pd-l-100 {
      padding-left: 10px;
    }
  }
  @media (min-width: 425px) and (max-width: 768px){
    .text-size-45 {
      font-size: 26px;
    }
    .text-size-40 {
      font-size: 20px;
    }
    .text-size-20 {
      font-size: 14px;
    }
    .text-size-22 {
      font-size: 16px;
    }
    .text-size-24 {
      font-size: 14px;
    }
    .pd-r-100 {
      padding-right: 30px;
    }
    .pd-l-100 {
      padding-left: 30px;
    }
  }
  @media (min-width: 1024px) {
    .modal-lg {
      width: 800px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/warehouses/UpgradePlanModal.vue